// ─── پیکربندی برند/آدرس‌ها ───────────────────────────────────────────────
// همه‌ی مقادیر در زمان build از env (REACT_APP_*) خوانده می‌شوند.
// پیش‌فرض هر متغیر دقیقاً مقدار فعلی «هنری» است تا build بدون env
// هیچ تغییر رفتاری نداشته باشد؛ فقط با ست‌کردن env برای مشتری جدید عوض می‌شود.

// بک‌اند ادمین فروشگاه (shop_admin_backend_laravel — aa.honari.com)
export const apiUrl = process.env.REACT_APP_API_URL || "https://aa.honari.com";

// سایت اصلی فروشگاه (ریدایرکت لاگین، لینک نمایش محصول، ...)
export const siteUrl = process.env.REACT_APP_SITE_URL || "https://honari.com";

// پنل ادمین جدید (AdminNext15) و بک‌اند آن (AdminLaravel12)
export const panelUrl = process.env.REACT_APP_PANEL_URL || "https://panel.honari.com";
export const panelApiUrl = process.env.REACT_APP_PANEL_API_URL || "https://pa.honari.com";

// ادمین قدیمی Yii
export const oldAdminUrl = process.env.REACT_APP_OLD_ADMIN_URL || "https://admin.honari.com";

// بک‌اند فروشگاه (shop_backend_laravel_12) — پیش‌فرض: پشت siteUrl روی مسیر /sa
export const shopApiUrl = process.env.REACT_APP_SHOP_API_URL || siteUrl + "/sa";

// فایل‌ها / OSS
// export const ossUrl = "https://statics.honari.com/honarifiles";
// export const imagesBsaeUrl = "https://statics.honari.com/honarifiles";
export const ossUrl = process.env.REACT_APP_OSS_URL || "https://f.honari.com/honariobject";
export const imagesBsaeUrl = process.env.REACT_APP_IMAGES_BASE_URL || "https://f.honari.com/honariobject/honariobject";

// نام برند (عنوان تب و هدر سایدبار)
export const brandName = process.env.REACT_APP_BRAND_NAME || "هنری";

// واترمارک پس‌زمینه‌ی صفحات اکسل/انبارگردانی
export const watermarkUrl = process.env.REACT_APP_WATERMARK_URL || siteUrl + "/assets/images/main_images/honari.png";
